/*
	Image Archive URLs
	These apis are meant for working with the Columbia_Info zip files.
*/

import { readPrerenderedData } from "@fluke/is2u-prerendered-data";
import JSZip from 'jszip';

export async function _unpackImageArchive(blob, name) {
  if (!blob) return;

  let is2uError = null;

  try {
    const preRenderedData = await readPrerenderedData(blob);
    const preview = URL.createObjectURL(preRenderedData.previewImage);
    const visual = URL.createObjectURL(preRenderedData.vlImage);
    const photonotes = preRenderedData.photonotes.map((photo) => {
      return {
        src: URL.createObjectURL(photo.src),
        name,
      };
    });
    return {
      name,
      imageJSON: preRenderedData.prerenderedInfo,
      preview,
      visual,
      photonotes,
    };
  } catch (error) {
    // Save the error to log if blob doesn't end up being a legacy format
    is2uError = error;
  }

  // If the above fails, it should be a columbia info archive (legacy/pre-IS2U)
  try {
    const unzipped = await JSZip.loadAsync(blob);
    const unpacked = await _unpackColumbiaInfo(unzipped);
    return {
      name,
      ...unpacked,
    };
  }
  catch (error) {
    console.error(`Legacy format error: ${error}`)
  }

  if (is2uError) {
    console.error(`Error unpacking IS2U data: ${is2uError}`);
  }
}

export async function _unpackColumbiaInfo(unzipped) {
  return new Promise((resolve, reject) => {
    const imageJSONPromise = unzipped
      .file('columbia_info.json')
      .async('string')
      .then((res) => JSON.parse(res));

    const previewPromise = unzipped
      .file('preview.jpg')
      .async('blob')
      .then((res) => URL.createObjectURL(res));

    const visualPromise = unzipped
      .file('visual.jpg')
      .async('blob')
      .then((res) => URL.createObjectURL(res));

    const photonotePromises = [];
    unzipped.folder('photonotes').forEach((relativePath, file) => {
      const photonotePromise = file
        .async('blob')
        .then((blob) => {
          const photonote = URL.createObjectURL(blob);
          return { name: file.name, src: photonote };
        })
        .catch(reject);
      photonotePromises.push(photonotePromise);
    });

    Promise.all([imageJSONPromise, previewPromise, visualPromise, ...photonotePromises])
      .then(([imageJSON, preview, visual, ...photonotes]) => {
        resolve({ imageJSON, preview, visual, photonotes });
      })
      .catch(reject);
  });
}

async function _fetchImageArchive(url) {
    const response = await fetch(url);
  if (!response.ok) {
    throw new Error(response.statusText);
  }

  return await response.blob();
}

async function _fetchImageArchiveByUrl(pURL, name) {
  let imageData = {};
  if (pURL == null) return imageData;

  const data = await _fetchImageArchive(pURL);
  imageData = await _unpackImageArchive(data, name);

  // get the image id
  const {
    imageJSON: {
      main: { image_id },
    },
  } = imageData;

  // append extra data
  imageData.url = pURL;
  imageData.imageId = image_id;

  return imageData;
}

export const imageArchive = {
  fetchImageArchiveByUrl:_fetchImageArchiveByUrl,
  unpackImageArchive:_unpackImageArchive,
  fetchImageArchive:_fetchImageArchive
};

